import {
  DeleteCollectionEntryMutation,
  useDeleteCollectionEntryMutation,
  withStandardDeleteHook,
} from '@spotify/confidence-graphql';

export const useDeleteCollectionEntry = withStandardDeleteHook<
  DeleteCollectionEntryMutation,
  'deleteCollectionEntry'
>(useDeleteCollectionEntryMutation, 'deleteCollectionEntry', {
  update: (cache, _, { variables }) => {
    if (variables?.name) {
      cache.evict({
        id: cache.identify({
          __typename: 'CollectionsV1CollectionEntry',
          name: variables.name,
        }),
      });
      cache.gc();
    }
  },
});
